import { PersonHttpHelper, NO_DATA_MESSAGE } from '@usas/ui-web/utils/HttpHelper';

const PostPersonParentChildByMemberIdData = (memberId, state, setState) => {
  if (state.isSaving !== true && !state.message) {
    let newState = {
      ...state,
      isSaving: true,
      isSaved: false,
      message: 'Saving...'
    };
    setState(newState);

    const memberIdForUrl = memberId ? encodeURIComponent(memberId) : 'NaN';
    const url = `/PersonParentChild/Member/${memberIdForUrl}`;
    PersonHttpHelper(url, 'POST')
      .then((objData) => {
        if (!objData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          newState = {
            ...newState,
            isSaving: false,
            isSaved: true,
            isObjLoaded: true,
            objData,
            message: '',
          };
          setState(newState);
          return objData;
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isSaving: false,
          isSaved: false,
          isObjLoaded: false,
          message: message
        });
      });
  }
};

export default PostPersonParentChildByMemberIdData;